import { pathToRegexp } from 'path-to-regexp'
import { type AnyObject } from '#types/common'

export interface Route {
	path: string
	route: (...props: string[]) => string
	regex: RegExp
	isProtected: boolean
}

/**
 * Create a new route in the routing system
 * @param path `string` The path. Set params here with `:param` notation.
 * @param callback `null, undefined or function` using the `:param` to substitute the params in the `path`
 * @param protect `boolean`, to indicate if the route is protected. Defaults to false.
 * @returns Route object.
 */
export const createRoute = (
	path: string,
	callback?: ((...props: string[]) => string) | null,
	protect = false,
): Route => {
	return {
		path,
		route: callback ?? (() => path),
		regex: pathToRegexp(path),
		isProtected: protect,
	}
}

export const renameKeys = (
	obj: AnyObject<any>,
	prefix: string,
): AnyObject<any> => {
	const keyValues = Object.keys(obj).map(key => {
		const newKey = `${prefix}_${key}`
		return { [newKey]: obj[key] }
	})
	return Object.assign({}, ...keyValues)
}

export const arrayToObject = (arr: any[]) => {
	const finalObject = {}

	for (let i = 0; i < arr.length; i++) {
		Object.assign(finalObject, arr[i])
	}

	return finalObject
}
